import { Table } from "antd";

export default function CustomTable({ columns = [], data = [], ...props }) {
  return (
    <Table
      rowKey={(record) => record.id ?? record.key}
      columns={columns}
      dataSource={data}
      bordered
      {...props}
    />
  );
}
